export default __webpack_public_path__ + "static/media/curatr.a95a882a.png";